export enum FontFamilyType {
  '宋体' = 'SimSun',
  '黑体' = 'SimHei',
  '微软雅黑' = 'Microsoft Yahei',
  '微软正黑体' = 'Microsoft JhengHei',
  '楷体' = 'KaiTi',
  '新宋体' = 'NSimSun',
  '仿宋' = 'FangSong',
  '华文黑体' = 'STHeiti',
  '冬青黑体简' = 'Hiragino Sans GB',
  '兰亭黑-简' = 'Lantinghei SC',
  '翩翩体-简' = 'Hanzipen SC',
  '手札体-简' = 'Hannotate SC',
  '宋体-简' = 'Songti SC',
  '娃娃体-简' = 'Wawati SC',
  '魏碑-简' = 'Weibei SC',
  '行楷-简' = 'Xingkai SC',
  '雅痞-简' = 'Yapi SC',
  '圆体-简' = 'Yuanti SC',
  '幼圆' = 'YouYuan',
  '隶书' = 'LiSu',
  '华文细黑' = 'STXihei',
  '华文楷体' = 'STKaiti',
  '华文宋体' = 'STSong',
  '华文仿宋' = 'STFangsong',
  '华文中宋' = 'STZhongsong',
  '华文彩云' = 'STCaiyun',
  '华文琥珀' = 'STHupo',
  '华文新魏' = 'STXinwei',
  '华文隶书' = 'STLiti',
  '华文行楷' = 'STXingkai',
  '方正舒体' = 'FZShuTi',
  '方正姚体' = 'FZYaoti',
  '思源黑体' = 'Source Han Sans CN',
  '思源宋体' = 'Source Han Serif SC',
  '文泉驿微米黑' = 'WenQuanYi Micro Hei'
}
